import React, { useEffect, useRef, useState } from "react";
import BasicModal from "./MuiModalImageList.jsx";
import MediaSkeleton from "./skeletons/MediaSkeleton.jsx";
import CarouselModal from "./MUIModalCarousel.jsx";
import * as Utils from "../utils/Utils.js";
import { hideIntercom } from "../utils/Utils.js";
const Media = ({ media, mainUrl, loading, context }) => {
  const [data, setData] = useState([]);
  const carouselIndexRef = useRef();
  const isEventPage = context === "Event";

  useEffect(() => {
    const fetchData = async () => {
      let content = [];
      const imageFiles = /\.(jpg|jpeg|png|gif)$/i;

      if (media) {
        for (let i = 0; i < media.length; i++) {
          if (media[i].title === "photo" || imageFiles.test(media[i].src)) {
            content.push(media[i]);
          } else {
            let source = media[i].src;
            let result2 = await Promise.all([
              fetch("https://youtube.com/oembed?url=" + source).then((res) =>
                res.json()
              ),
            ]).catch(() => undefined);

            if (result2) {
              content.push(result2[0]);
            }
          }
        }
      }

      setData(content);
    };

    fetchData();
  }, [media]);

  const openCarouselModal = (e) => {
    const masonryOpen = document.querySelector("#r_closeMasonry");
    if (masonryOpen) {
      masonryOpen.click();
      document.documentElement.style.overflow = "hidden";
      hideIntercom();
    }

    carouselIndexRef.current.focusIndex(
      parseInt(e.target.getAttribute("data-target"))
    );
    carouselIndexRef.current.handleOpen();
  };

  const getMasonryContent = () => {
    let eventTitle = Utils.getEventTitle();
    let content = [];

    data.forEach((item, i) => {
      if (item.type === "video") {
        let thumbnail =
          "https://img.youtube.com/vi/" +
          item.thumbnail_url.split("vi/")[1].substring(0, 11) +
          "/sddefault.jpg";

        content.push(
          <div key={"masonryItem" + i} className={"masonryItem r_video"}>
            <img
              alt={eventTitle}
              data-target={i}
              loading="lazy"
              src={thumbnail}
              onClick={openCarouselModal}
            />
            <a className="r_mediaPlayVideoIcon"></a>
          </div>
        );
      } else {
        content.push(
          <div key={"masonryItem" + i} className={"masonryItem"}>
            <img
              alt={eventTitle}
              data-target={i}
              loading="lazy"
              src={item.src}
              onClick={openCarouselModal}
            />
          </div>
        );
      }
    });

    return content;
  };

  let media1 = [];
  let media23 = [];
  let eventTitle = Utils.getEventTitle();
  let masonryContent = getMasonryContent();

  if (data.length > 0) {
    if (data.length === 1) {
      const item = data[0];
      if (item.type === "video") {
        let thumbnail =
          "https://img.youtube.com/vi/" +
          item.thumbnail_url.split("vi/")[1].substring(0, 11) +
          "/sddefault.jpg";
        media1.push(
          <div
            key={"mediaItem1"}
            className={"r_mediaItem1 r_video1 r_mediumSingleMax"}
          >
            <img
              data-target={0}
              alt={eventTitle}
              onClick={openCarouselModal}
              src={thumbnail}
            />
            <a className="r_mediaPlayVideoIcon"></a>
          </div>
        );
      } else {
        media1.push(
          <div key={"mediaItem1"} className={"r_mediaItem1 r_mediumSingleMax"}>
            <img
              alt={eventTitle}
              data-target={0}
              onClick={openCarouselModal}
              src={item.src}
            />
          </div>
        );
      }
    } else if (data.length === 2) {
      for (let i = 0; i < 2; i++) {
        const item = data[i];
        const isVideo = item.type === "video";
        const thumbnail = isVideo
          ? "https://img.youtube.com/vi/" +
            item.thumbnail_url.split("vi/")[1].substring(0, 11) +
            "/sddefault.jpg"
          : null;

        if (i === 0) {
          media1.push(
            <div
              key={"mediaItem" + (i + 1)}
              className={
                "r_mediaItem" +
                (i + 1) +
                " r_video" +
                (i + 1) +
                " r_mediumDoubleMax"
              }
            >
              <img
                alt={eventTitle}
                data-target={i}
                onClick={openCarouselModal}
                src={isVideo ? thumbnail : item.src}
              />
              {isVideo && <a className="r_mediaPlayVideoIcon"></a>}
            </div>
          );
        } else {
          media23.push(
            <div
              key={"mediaItem" + (i + 1)}
              className={
                "r_mediaItem" +
                (i + 1) +
                " r_video" +
                (i + 1) +
                " r_mediumDoubleMax"
              }
            >
              <img
                alt={eventTitle}
                data-target={i}
                onClick={openCarouselModal}
                src={isVideo ? thumbnail : item.src}
              />
              {isVideo && <a className="r_mediaPlayVideoIcon"></a>}
            </div>
          );
        }
      }
    } else {
      for (let i = 0; i < 3; i++) {
        const item = data[i];
        const isVideo = item.type === "video";
        const thumbnail = isVideo
          ? "https://img.youtube.com/vi/" +
            item.thumbnail_url.split("vi/")[1].substring(0, 11) +
            "/sddefault.jpg"
          : null;

        if (i === 0) {
          media1.push(
            <div
              key={"mediaItem" + (i + 1)}
              className={
                "r_mediaItem" +
                (i + 1) +
                " r_video" +
                (i + 1) +
                " r_mediumTripleMax"
              }
            >
              <img
                alt={eventTitle}
                data-target={i}
                src={isVideo ? thumbnail : item.src}
                onClick={openCarouselModal}
              />
              {isVideo && <a className="r_mediaPlayVideoIcon"></a>}
              <BasicModal items={masonryContent} />
            </div>
          );
        } else {
          media23.push(
            <div
              key={"mediaItem" + (i + 1)}
              className={
                "r_mediaItem" +
                (i + 1) +
                " r_video" +
                (i + 1) +
                " r_mediumTripleMax"
              }
            >
              <img
                alt={eventTitle}
                data-target={i}
                onClick={openCarouselModal}
                src={isVideo ? thumbnail : item.src}
              />
              {isVideo && <a className="r_mediaPlayVideoIcon"></a>}
            </div>
          );
        }
      }
    }
  }

  let secondaryMedia = null;
  if (media23.length > 0) {
    secondaryMedia = (
      <div
        id="r_eventMedia23"
        className={`r_eventMedia23 ${
          media23.length === 1 ? "r_eventMedia23Double" : ""
        }`}
      >
        {media23}
      </div>
    );
  }

  if (loading) return <MediaSkeleton isEventPage={isEventPage} />;

  return (
    media.length > 0 && (
      <>
        <div
          id="r_eventMedia"
          style={{ display: "flex", flexDirection: "column", gap: 24 }}
        >
          {!isEventPage && (
            <span
              style={{
                color: "#0D0C1C",
                fontSize: 20,
                fontFamily: "pf_highway_sans_pro_mediumRg",
                marginLeft: 16,
              }}
            >
              {playdetailsv2_resources.Gallery}
            </span>
          )}
          <div
            className={"r_eventMedia" + (media1.length === 0 ? " r_hide" : "")}
            {...(!isEventPage && { style: { margin: "0 16px" } })}
          >
            {media1}
            {secondaryMedia}
          </div>
        </div>
        <CarouselModal ref={carouselIndexRef} items={data} mainUrl={mainUrl} />
      </>
    )
  );
};

export default Media;
